import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from './contexts/AuthContext'
import { SocketProvider } from './contexts/SocketContext'
import { ChatProvider } from './contexts/ChatContext'
import App from './App'
import './styles/index.css'

// Interceptor global de fetch para tratar erros de autenticação (401) em qualquer chamada da plataforma
const originalFetch = window.fetch
window.fetch = async (...args) => {
    try {
        const response = await originalFetch(...args)
        if (response.status === 401) {
            // Ignorar redirecionamento se já estiver no login ou cadastro para manter validação local
            if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/cadastro')) {
                localStorage.removeItem('token')
                localStorage.removeItem('usuario')
                window.location.href = '/login?sessao_expirada=true'
            }
        }
        return response
    } catch (error) {
        return Promise.reject(error)
    }
}

// O Client ID pode ser injetado por variáveis de ambiente do Vite
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'SEU_CLIENT_ID_AQUI'

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={clientId}>
            <BrowserRouter>
                <AuthProvider>
                    <SocketProvider>
                        <ChatProvider>
                            <App />
                        </ChatProvider>
                    </SocketProvider>
                </AuthProvider>
            </BrowserRouter>
        </GoogleOAuthProvider>
    </React.StrictMode>
)
